export default __webpack_public_path__ + "static/media/03_photo.6bb00512.jpg";